import React from "react";

let body;

const MessagesPopup = React.createClass({
    getInitialState: function () {
        return {
            isHidden: this.props.isHidden,
            goTop: this.props.goTop || false,
            classMessage: this.props.classMessage
        };
    },

    componentWillReceiveProps: function (nextProps) {
        this.state.isHidden = nextProps.isHidden;
        this.state.goTop = nextProps.goTop;
        this.state.classMessage = nextProps.classMessage;
    },

    componentDidMount: function () {
        body = $("html, body");
    },

    closeMessagePopup: function () {
        this.setState({ isHidden: true });
    },

    render: function () {
        let component = null;
        let iconClass = "";

        if (this.state.isHidden == false) {
            if (body && this.state.goTop) {
                body.stop().animate({ scrollTop: 0 }, "800");
            }

            switch (this.state.classMessage) {
                case "info": { iconClass = "zmdi-info"; break; }
                case "error": { iconClass = "zmdi-alert-circle"; break; }
                case "success": { iconClass = "zmdi-check-circle"; break; }
                case "warning": { iconClass = "zmdi-alert-triangle"; break; }
                default: { iconClass = ""; break; }
            }

            component = (<div className={"container-message-onscreen " + this.state.classMessage}>
                <div className="zmdi">
                    <div className="message">
                        <label className={"word-break-all " + iconClass}>
                            {this.props.message}
                        </label>
                    </div>
                </div>
            </div>);
        }

        return (component);
    }
});
export default MessagesPopup;